import React from 'react';
import { Col, Row, Input, Button } from 'components';
import { FilterIcon } from 'components/common/icons';
import { PurchaseOrderItemsTable } from './PurchaseOrderItemsTable';
import { PurchaseOrderItemsProps } from './types';
import { usePurchaseOrderItems } from './usePurchaseOrderItems';
import { ItemFiltersDrawer } from './ItemFiltersDrawer';
import styles from './styles.module.scss';

const { Search } = Input;

export const PurchaseOrderItems: React.FC<PurchaseOrderItemsProps> = ({ purchaseOrderId }) => {
  const {
    data,
    isLoading,
    pagination,
    form,
    handleTableChange,
    onSearch,
    filterDrawerVisible,
    openFilterDrawer,
    closeFilterDrawer,
    applyFilters,
    resetFilters,
    totalElements,
  } = usePurchaseOrderItems({ purchaseOrderId });

  return (
    <div className={styles.itemsContainer}>
      <Row gutter={[0, 16]}>
        <Col span={24}>
          <Row justify="space-between" align="middle">
            <Col>
              <h3 style={{ margin: 0 }}>Items</h3>
            </Col>
            <Col>
              <Row gutter={8} align="middle">
                <Col>
                  <Search
                    placeholder="Search items..."
                    allowClear
                    style={{ width: 300 }}
                    onChange={(e) => onSearch(e.target.value)}
                  />
                </Col>
                <Col>
                  <Button color="default" variant="filled" onClick={openFilterDrawer} icon={<FilterIcon />} />
                </Col>
              </Row>
            </Col>
          </Row>
        </Col>
        <Col span={24}>
          <PurchaseOrderItemsTable
            data={data}
            loading={isLoading}
            pagination={pagination}
            onTableChange={handleTableChange}
            totalElements={totalElements}
          />
        </Col>
      </Row>
      <ItemFiltersDrawer
        visible={filterDrawerVisible}
        onClose={closeFilterDrawer}
        form={form}
        onApply={applyFilters}
        onReset={resetFilters}
      />
    </div>
  );
};
